import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import parse from 'html-react-parser';
import * as DOMPurify from 'dompurify';

import { getRandomString } from '../../util/text';

class HtmlComponent extends Component {
    constructor(props) {
        super(props);
        this.key = getRandomString(30);
    }

    // transform = (node, index) => {
    // }

    renderHtml() {
        // if(this.props.text) {
        //     return reactHtmlParser(this.props.text, {
        //         transform: this.transform,
        //     });
        // }
        return DOMPurify.sanitize(this.props.text);
    }

    render() {
        return <span key={this.key} className={classnames('html-text-wrapper', this.props.inline ? 'd-inline' : 'd-block')} dangerouslySetInnerHTML={{ __html: this.renderHtml() }} />;
    }
}

HtmlComponent.defaultProps = {
    inline: false,
};

HtmlComponent.propTypes = {
    text: PropTypes.string.isRequired,
    inline: PropTypes.bool,
};

export default HtmlComponent;
